import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Button } from '@scio3/ui';

type Props = {
  open: boolean;
  onContinue: () => void;
};

/**
 * Payment success confirmation — scio1 parity for `/payment-thankyou` content,
 * surfaced as a popup instead of a redirect (#1114).
 */
export function PaymentThankYouDialog({ open, onContinue }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onContinue()}>
      <DialogContent
        className="sm:max-w-md flex flex-col overflow-hidden"
        data-testid="payment-thank-you-dialog"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-primary" />
            {t('Thank You!')}
          </DialogTitle>
        </DialogHeader>

        <div className="py-2 text-sm text-foreground">
          {t('Your payment information has been updated successfully')}
        </div>

        <DialogFooter>
          <Button onClick={onContinue} className="cursor-pointer">
            {t('Continue')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
